/** Persist BuzzBridge UI context (e.g. referral surfaces). Does not affect API x-app-name. */
export const BUZZBRIDGE_SIGNUP_CONTEXT_KEY = 'buzzbridge_signup_context';

export function setBuzzBridgeSignupContext(on: boolean): void {
    if (typeof window === 'undefined') return;
    try {
        if (on) sessionStorage.setItem(BUZZBRIDGE_SIGNUP_CONTEXT_KEY, '1');
        else sessionStorage.removeItem(BUZZBRIDGE_SIGNUP_CONTEXT_KEY);
    } catch {
        // ignore
    }
}

/** True when the user is in a BuzzBridge surface (dashboard, landing, rewards). */
export function isBuzzBridgeAppContext(): boolean {
    if (typeof window === 'undefined') return false;
    try {
        if (sessionStorage.getItem(BUZZBRIDGE_SIGNUP_CONTEXT_KEY) === '1') return true;
    } catch {
        // ignore
    }
    const path = window.location.pathname.toLowerCase();
    if (path.includes('/buzzbridge')) return true;
    const tab = new URLSearchParams(window.location.search).get('tab');
    return tab === 'buzzbridge';
}
